
import React from 'react';
import ResourcePageLayout from '@/components/layouts/ResourcePageLayout';
import { Heart, Users, Award, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

const ForCouples = () => {
  const sections = [
    {
      title: "Shared Health Challenges",
      icon: Users,
      content: "Hormonal health affects both partners. When one partner experiences hormonal imbalances, it can impact mood, energy, and intimacy in the relationship. Understanding each other's hormonal patterns creates empathy and strengthens connection. Hormone Balance Guide provides resources for both partners to understand these challenges."
    },
    {
      title: "Joint Wellness Tips",
      icon: Heart,
      content: "Supporting each other's wellness journey is key to a thriving relationship. From nutrition plans that benefit both partners to stress-reduction activities you can do together, Hormone Balance Guide offers practical guidance for couples. Our couples-focused approach emphasizes communication, mutual support, and shared wellness goals."
    },
    {
      title: "Couples' Success Stories",
      icon: Award,
      content: "Many couples have transformed their relationship by addressing hormonal health together. Read stories of partners who have supported each other through hormonal challenges, learned to communicate better about health needs, and discovered new ways to nurture their connection through wellness practices."
    }
  ];
  
  return (
    <ResourcePageLayout 
      title="For Couples" 
      description="Discover how Hormone Balance Guide can support both partners in achieving hormonal harmony."
    >
      <div className="bg-Hormone Balance Guide-cream/30 p-6 rounded-xl mb-8 border border-Hormone Balance Guide-beige">
        <h2 className="text-xl font-semibold text-Hormone Balance Guide-charcoal mb-3">
          Better Together: The Couple's Approach to Hormonal Health
        </h2>
        <p className="text-Hormone Balance Guide-charcoal/80">
          Hormonal health doesn't exist in isolation. When partners understand and support each other's hormonal journey, both individuals benefit. Hormone Balance Guide provides tools, insights, and resources specifically designed for couples navigating hormonal health together.
        </p>
      </div>
      
      <div className="space-y-8">
        {sections.map((section, index) => (
          <div key={index} className="bg-white p-6 rounded-lg border border-Hormone Balance Guide-beige/50 shadow-sm">
            <div className="flex items-center gap-3 mb-3">
              <div className="bg-Hormone Balance Guide-coral/10 p-2 rounded-full">
                <section.icon className="text-Hormone Balance Guide-coral" size={24} />
              </div>
              <h3 className="text-xl font-semibold text-Hormone Balance Guide-charcoal">{section.title}</h3>
            </div>
            <p className="text-Hormone Balance Guide-charcoal/80">{section.content}</p>
          </div>
        ))}
      </div>
      
      <div className="mt-10 bg-Hormone Balance Guide-coral/10 p-6 rounded-lg border border-Hormone Balance Guide-coral/20">
        <h3 className="text-xl font-semibold text-Hormone Balance Guide-charcoal mb-3">Ready to start your journey together?</h3>
        <p className="text-Hormone Balance Guide-charcoal/80 mb-4">
          Create accounts for both partners and unlock special couples features to support each other's hormonal wellness journey.
        </p>
        <Button 
          variant="coral" 
          size="lg"
          onClick={() => window.open("https://a.co/d/c3xXKiD", "_blank")}
        >
          <span>Get Started Together</span>
          <ArrowRight size={18} />
        </Button>
      </div>
    </ResourcePageLayout>
  );
};

export default ForCouples;
